import React from "react";
import styled from "styled-components";
import Header from "../header/header";
import StaticFooter from "../footer/footer-static";

const Container = styled.div`
	width: 90%;
	max-width: 1200px;
	margin: auto;
	min-height: 50vh;
	@media (min-width: 768px) {
		width: 80%;
	}
`;

const Title = styled.h2`
	font-weight: bold;
	font-size: 32px;
	margin-top: 32px;
	margin-bottom: 8px;
`;

const p = styled.p`
	font-weight: normal;
	font-size: 17px;
	margin: 0;
	margin-bottom: 32px;
`;

const CeilingSpraying = () => (
	<div>
		<Container>
			<Header />
			<a href="/" alt="home">
				&#8592; Back to Home
			</a>
			<Title>Ceiling Spraying & Ceiling Refurbishment</Title>
			<p>
				There are all kinds of ceilings; the most popular ceilings are mineral
				fibre ceiling with the inserted tiles in the grid, when resprayed they
				look new any damage tiles are easily replaced and also can be refinished
				in any colour to match. <br />
				<br />
				Open cell ceilings <br />
				Metal ceilings <br />
				Plaster board <br /> <br />
				All can be refinished to match any Ral code; if you have the colour we
				have the finish <br />
				Please see our gallery photos
			</p>
		</Container>
		<StaticFooter />
	</div>
);

export default CeilingSpraying;



// WEBPACK FOOTER //
// ./src/components/page/ceiling-spraying.js